import GuestLayout from '@/layouts/Guest.vue'

import RegistrationTokenGuard from '@/router/guards/registration-token'
import Login from '@/views/auth/Login.vue'
import ForgotPassword from '@/views/auth/ForgotPassword.vue'
import ResetPassword from '@/views/auth/ResetPassword.vue'
import CreateAdmin from '@/views/app/users/CreateAdmin.vue'
import multiGuard from '@/router/multi-guard'
import GuestGuard from '../guards/guest'

export default [
    {
        path: '/',
        component: GuestLayout,
        children: [
            {
                path: 'login/:registrationToken',
                name: 'login-token',
                component: Login,
                beforeEnter: multiGuard([RegistrationTokenGuard, GuestGuard]),
                props: true,
            },
            {
                path: 'login',
                name: 'login',
                component: Login,
                beforeEnter: GuestGuard,
            },
            {
                path: 'forgot-password',
                name: 'forgot-password',
                component: ForgotPassword,
                beforeEnter: GuestGuard,
            },
            {
                path: 'auth/:token/reset-password',
                name: 'reset-password',
                component: ResetPassword,
            },
            {
                path: 'registration/:registrationToken',
                name: 'create-admin',
                component: CreateAdmin,
                beforeEnter: multiGuard([GuestGuard, RegistrationTokenGuard]),
                props: true,
            },
        ],
    },
]
